<template>
    <table-template actionUrl="/distributor/findDbtThirdPartyToolsConsumeRecords.action" ref="consume-records" :queryParams="queryParams">
        <template slot="search">
            <el-select v-model="queryParams.type" @change="$refs['consume-records'].search()" clearable  placeholder="请选择状态">
                <el-option label="维保查询" :value="1"></el-option>
                <el-option label="碰撞查询" :value="2"></el-option>
                <el-option label="商品活动" :value="3"></el-option>
            </el-select>

            <el-date-picker
                    clearable
                    style="margin-left: 10px;"
                    v-model="createTimeSearch"
                    @change="onCreateTimeChanged"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="创建时间开始"
                    end-placeholder="创建时间截止">
            </el-date-picker>

            <el-input style="margin-left: 10px;width: 200px;" v-model="queryParams.keyword" placeholder="用户账号"></el-input>
            <el-button style="margin-left: 10px;" type="primary" @click="$refs['consume-records'].search()">搜索</el-button>
        </template>

        <template slot="item">
            <el-table-column
                    prop="id"
                    label="编号">
            </el-table-column>
            <el-table-column
                    label="类型">
                <template scope="scope">
                    <span v-bind:style="{color:getTypeColor(scope.row.type)}">{{scope.row.type | typeFilter}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="支出成本（元）">
                <template scope="scope">
                    {{scope.row.money/100}}
                </template>
            </el-table-column>
            <el-table-column
                    label="支出时间">
                <template scope="scope">
                    {{scope.row.createTime | dateTimeFormat}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="memberPhone"
                    label="关联用户账号">
            </el-table-column>
        </template>
    </table-template>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'
export default {
  name: 'other-service-expenditure',
  data () {
    return {
      createTimeSearch: null,
      queryParams: {}
    }
  },
  components: { TableTemplate },
  filters: {
    typeFilter (value) {
      let filter_value = '暂无'
      switch (value) {
        case 1:// 维保查询
          filter_value = '维保查询'
          break
        case 2:// 碰撞查询
          filter_value = '碰撞查询'
          break
        case 3:// 商品活动
          filter_value = '商品活动'
          break
      }
      return filter_value
    }
  },
  methods: {
    onCreateTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
        this.$refs['consume-records'].search()
        return
      }
      this.queryParams.startTime = datetime[0].getTime()
      this.queryParams.endTime = datetime[1].getTime()
      this.$refs['consume-records'].search()
    },
    getTypeColor (status) {
      let color = ''
      switch (status) {
        case 1:// 维保查询
          color = '#409EFF'
          break
        case 2:// 碰撞查询
          color = '#67C23A'
          break
        case 3:// 商品活动
          color = '#E6A23C'
          break
      }
      return color
    }
  }
}
</script>
